import { cn } from "@/lib/utils";

import {
  type RightPanelTab,
  useRightPanelStore,
} from "../../store/rightPanelStore";

interface Props {
  readonly activeTab: RightPanelTab;
  readonly onTabChange: (tab: RightPanelTab) => void;
  readonly hasSelectedBead?: boolean;
  readonly onBack?: () => void;
}

export function TaskPanelHeader({
  activeTab,
  onTabChange,
  hasSelectedBead = false,
  onBack,
}: Props) {
  const close = useRightPanelStore((s) => s.close);

  return (
    <div className="flex items-center justify-between gap-2 border-b border-home-ink/8 px-3 py-2.5 dark:border-white/10">
      {hasSelectedBead && onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1 rounded-full px-2.5 py-1.5 font-body text-[13px] font-semibold text-home-ink/60 transition-colors hover:bg-home-ink/[0.05] hover:text-home-ink dark:text-white/60 dark:hover:bg-white/5"
        >
          <span aria-hidden="true">←</span> Back
        </button>
      ) : null}

      {/* Segmented control — sentence case, warm tokens, one shared language
          with the landing/integrations pills. */}
      <div
        className={cn(
          "inline-flex gap-0.5 rounded-full bg-home-ink/[0.05] p-0.5 dark:bg-white/10",
          hasSelectedBead && "hidden",
        )}
      >
        {(["spec", "execution"] as const).map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => onTabChange(tab)}
            className={cn(
              "rounded-full px-4 py-1.5 font-body text-[13px] font-semibold transition-all",
              activeTab === tab
                ? "bg-white text-home-ink shadow-[0_2px_8px_-4px_rgba(33,31,28,0.35)] dark:bg-white/15 dark:text-white"
                : "text-home-ink/55 hover:text-home-ink dark:text-white/55 dark:hover:text-white",
            )}
          >
            {tab === "spec" ? "Workflow" : "Flow"}
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={() => close()}
        aria-label="Close workflow panel"
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-home-ink/50 transition-colors hover:bg-home-ink/[0.05] hover:text-home-ink dark:text-white/50 dark:hover:bg-white/5"
      >
        <span aria-hidden="true" className="text-base leading-none">
          ×
        </span>
      </button>
    </div>
  );
}
